var Curriculog = Curriculog || {};

Curriculog.SimpleFilter = (function ($, _, Backbone, SimpleFilter) {

	SimpleFilter = Curriculog.CurriculogView.extend({

		el: function() {
			return $('#filterBy');
		},

		events: {
			'change': 'execute'
		},

		initialize: function(options) {
			this.user = options.user;
			this.params = options.params;
			this.defaultQueries = options.defaultQueries;
			this.reset();

			this.listenTo(Backbone, 'tabs:change', this.reset);
			this.listenTo(Backbone, 'advancedFilter:toggleOpen', this.disable);
			this.listenTo(Backbone, 'advancedFilter:toggleClosed', this.enable);

			if (this.params.domParams.get('filterType') === 'simple') {
				this.set();
			}

			// Initialize the select2 plugin
			this.$el.selectWoo({
				theme: 'curriculog'
			});
			var label = this.$el.next().find('.select2-selection--single').attr('aria-labelledby');
			this.$el.next().find('.select2-selection--single').attr('aria-labelledby', this.$el.attr('id') + '-label' + ' ' + label );


		},

		render: function(template) {
			return nunjucks.render('ProposalList/' + template + '.html',
				{
					user: this.user.attributes
				}
			);
		},

		execute: function() {
			var filter = $('select[name="filterBy"]').val(),
				defaultQuery;

			defaultQuery = this.defaultQueries[this.params.domParams.get('tab')].getDefaultParams();

			if (_.indexOf(this.getStatus(), filter) !== -1){
				var proposalStatus = filter.match(/proposal_status_(\w*)/)[1];
				defaultQuery.status = [proposalStatus];
				this.params.queryParams.set(defaultQuery);
			}
			else if (_.indexOf(this.getType(), filter) !== -1){
				var proposalType = filter.match(/proposal_type_(\w*)/)[1];
				defaultQuery.type = proposalType;
				this.params.queryParams.set(defaultQuery);
			}
			else if (_.indexOf(this.getAttention(), filter) !== -1){
				// TODO
				defaultQuery = this.defaultQueries.needsattention.getDefaultParams(filter);
				this.params.queryParams.set(defaultQuery);
			}
			else if (_.indexOf(this.getExport(), filter) !== -1){
				// TODO
				defaultQuery = this.defaultQueries.completed.getDefaultParams(filter);
				this.params.queryParams.set(defaultQuery);
			}
			else if (filter === 'urgent') {
				defaultQuery.flag = 'urgent';
				this.params.queryParams.set(defaultQuery);
			}
			else if (filter === 'deadline') {
				defaultQuery.deadline = 1;
				this.params.queryParams.set(defaultQuery);
			}
			else {
				this.params.queryParams.set(defaultQuery);
			}
			this.params.domParams.set('filterType', 'simple');
			this.params.domParams.set('simpleFilter', this.$el.val());

			// Broadcast get event
			Backbone.trigger('page:reset');
			Backbone.trigger('filter:submit');
		},

		set: function() {
			// When coming from a session when a simple filter was applied
			// reapply that filter in the UI
			var params = this.params;
			var simpleFilterParam = this.params.domParams.get('simpleFilter');
			this.$el.find('option[value="' + simpleFilterParam + '"]').prop('selected', 'selected');
		},

		reset: function() {
			// When switching tabs, change the text of the simple filter's
			// first option and adjust the available options
			this.$el.contents().remove();
			var html = this.render(this.getTemplate());
			this.$el.append(html);
			// Trigger the select2 change event to update the options and 'selected' option
			this.$el.trigger('change.select2');

			this.$el.find('option:eq(0)').prop('selected', true);
		},

		disable: function() {
			// when advanced filter is being used, reset
			// simple filter to top option and disable
			var filter = $('select[name="filterBy"]').val();

			this.reset();

			// if this is needs attention, we need to add a temporary option
			// for the entire data set that we will remove when we are done
			if (this.params.domParams.get('tab') == 'needsattention') {
				// Add a new Option object to append to the select2 element and then trigger the select2 change event
				var newOption = new Option('All Needs Attention', 'proposal_title', true, true);
				this.$el.prepend(newOption).trigger('change.select2');
			}

			// Set the disabled property to disable the select2 element
			// Add the `.select2()` for >=IE10 (https://github.com/select2/select2/issues/3246#issuecomment-145000478)
			this.$el.prop('disabled', true).selectWoo({
				theme: 'curriculog'
			});
			var label = this.$el.next().find('.select2-selection--single').attr('aria-labelledby');
			this.$el.next().find('.select2-selection--single').attr('aria-labelledby', this.$el.attr('id') + '-label' + ' ' + label );

		},

		enable: function() {
			// when advanced filter is cancelled, reset
			// simple filter to top option and enable
			this.reset();
			// Remove the disabled property to enable the select2 element
			// Add the `.select2()` for >=IE10 (https://github.com/select2/select2/issues/3246#issuecomment-145000478)
			this.$el.prop('disabled', false).selectWoo({
				theme: 'curriculog'
			});
			var label = this.$el.next().find('.select2-selection--single').attr('aria-labelledby');
			this.$el.next().find('.select2-selection--single').attr('aria-labelledby', this.$el.attr('id') + '-label' + ' ' + label );

		},

		warnAboutPrivateBrowsing: function () {
			this.showGrowl(
				'Private Browsing Enabled',
				'Filtered proposal searches will not be saved when private browsing is enabled'
			);
		},

		getTemplate: function() {
			// figure out which simpleFilter template we need to render
			// based on the tab selected
			// if guest, use a special tab name
			var tab = this.params.domParams.get('tab');
			if (this.user.get('id') === 0){
				tab = 'all-proposals-guest';
			}

			templates = {
				'task': 'simpleFilterTask',
				'mine': 'simpleFilterMine',
				'watching': 'simpleFilterWatching',
				'all-proposals': 'simpleFilterAllProposals',
				'all-proposals-guest': 'simpleFilterAllProposalsGuest',
				'needsattention': 'simpleFilterAttention',
				'completed': 'simpleFilterApproved',
				'manage-proposals': 'simpleFilterAllProposalsAdmin'
			};

			return templates[tab];
		},

		getStatus: function() {
			return [
				'proposal_status_active',
				'proposal_status_held',
				'proposal_status_suspended',
				'proposal_status_cancelled',
				'proposal_status_unlaunched',
				'proposal_status_waiting',
				'proposal_status_reviewing',
				'proposal_status_completed'
			];
		},

		getType: function() {
			return [
				'proposal_type_course',
				'proposal_type_program',
				'proposal_type_other'
			];
		},

		getAttention: function() {
			return [
				'request',
				'held',
				'suspended',
				'stuck',
				'reviewing',
				'empty',
				'all'
			];
		},

		getExport: function() {
			return [
				'exported',
				'not-exported'
			];
		}

	});

	return SimpleFilter;

})($, _, Backbone, Curriculog.SimpleFilter || {});
